import { render, staticRenderFns } from "./PaymentAcceptanceSettings.vue?vue&type=template&id=1dc28857"
import script from "./PaymentAcceptanceSettings.vue?vue&type=script&lang=js"
export * from "./PaymentAcceptanceSettings.vue?vue&type=script&lang=js"
import style0 from "./PaymentAcceptanceSettings.vue?vue&type=style&index=0&id=1dc28857&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports